// 🔧 index.js
// ✅ Purpose: Entry point for the Social Engine Demo add-on
// ✅ Features:
// - Exposes runSocialEngine()
// - Runs Social Builder when Social Engine is selected
// - Creates draft promotional social posts
// - Does NOT publish to any real social platform
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildSocial } from "./social_builder";

export const runSocialEngine = async ({ demoContext } = {}) => {
  console.log("📣 Social Engine started.");

  const result = await buildSocial({ demoContext });

  console.log("✅ Social Engine completed.", { result });

  return result;
};